// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-blog-js": function componentSrcPagesBlogJs() {
    return import("./../../src/pages/blog.js"
    /* webpackChunkName: "component---src-pages-blog-js" */
    );
  },
  "component---src-pages-categories-js": function componentSrcPagesCategoriesJs() {
    return import("./../../src/pages/categories.js"
    /* webpackChunkName: "component---src-pages-categories-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-specialists-js": function componentSrcPagesSpecialistsJs() {
    return import("./../../src/pages/specialists.js"
    /* webpackChunkName: "component---src-pages-specialists-js" */
    );
  },
  "component---src-pages-trainings-js": function componentSrcPagesTrainingsJs() {
    return import("./../../src/pages/trainings.js"
    /* webpackChunkName: "component---src-pages-trainings-js" */
    );
  },
  "component---src-templates-blog-page-js": function componentSrcTemplatesBlogPageJs() {
    return import("./../../src/templates/blog-page.js"
    /* webpackChunkName: "component---src-templates-blog-page-js" */
    );
  },
  "component---src-templates-category-page-js": function componentSrcTemplatesCategoryPageJs() {
    return import("./../../src/templates/category-page.js"
    /* webpackChunkName: "component---src-templates-category-page-js" */
    );
  },
  "component---src-templates-product-page-js": function componentSrcTemplatesProductPageJs() {
    return import("./../../src/templates/product-page.js"
    /* webpackChunkName: "component---src-templates-product-page-js" */
    );
  },
  "component---src-templates-specialist-page-js": function componentSrcTemplatesSpecialistPageJs() {
    return import("./../../src/templates/specialist-page.js"
    /* webpackChunkName: "component---src-templates-specialist-page-js" */
    );
  },
  "component---src-templates-training-page-js": function componentSrcTemplatesTrainingPageJs() {
    return import("./../../src/templates/training-page.js"
    /* webpackChunkName: "component---src-templates-training-page-js" */
    );
  }
};